// extracted by mini-css-extract-plugin
var _1 = "styles-module__button___hXnjf";
var _2 = "styles-module__next___zVwKj";
var _3 = "styles-module__previous___N9vmi";
var _4 = "styles-module__river___T3seM";
var _5 = "styles-module__riverItem___emdyc";
var _6 = "styles-module__riverTrack____B872";
var _7 = "styles-module__slickRiver___Rmg8C";
export { _1 as "button", _2 as "next", _3 as "previous", _4 as "river", _5 as "riverItem", _6 as "riverTrack", _7 as "slickRiver" }
